/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommStaffCardViewProps } from './ecomm-staff-card';

/**
 *
 * IEcommStaffCardViewProps component
 * @extends {React.PureComponent<IEcommStaffCardViewProps>}
 */
export class EcommStaffCardView extends React.PureComponent<IEcommStaffCardViewProps> {
  public render(): JSX.Element | null {
    const { name, position, TemplateContainerStyle, InfoContainerStyle } = this.props;

    return (
      <div className={TemplateContainerStyle.className}>
        {this._renderImage()}
        <div className={InfoContainerStyle.className}>
          <h6>{name}</h6>
          <p>{position}</p>
        </div>
      </div>
    );
  }

  private _renderImage(): JSX.Element | null {
    const { image, ImageContainerStyle, NoImage } = this.props;

    let result = <div className={NoImage.className}/>;

    if (image && image.src && image.src !== '') {
      result = <img src={image.src} alt='' role='presentation'/>;
    }

    return <div className={ImageContainerStyle.className}>{result}</div>;
  }
}

export default EcommStaffCardView;